import {ApiStreamer, ApiStreamerSocial} from "#/src/definitions/ApiDefinitions";
import {StreamerAvatar} from "#/src/components/streamer/StreamerAvatar";
import {getStreamerImageBySocialType} from "#/src/utils/social-utils";
import {Sort} from "#/src/utils/sort-utils";
import {StreamerGameIcon} from "#/src/components/streamer/StreamerGameIcon";
import {StreamerGameName} from "#/src/components/streamer/StreamerGameName";
import React from "react";
import styled from "@emotion/styled";

const Wrapper = styled.div`
  display: flex;
  height: 100%;
`;

interface Props {
  streamer: ApiStreamer,
  secondary?: boolean
}

export function StreamerCard({streamer, secondary = false}: Props) {
  function render() {
    return <div className="col-xl-3 col-md-4 col-sm-6">
      <Wrapper>
        <div className={`stream-card ${secondary ? "stream-card-secondary" : ""} w-100`}>
          {renderSocials()}
          <StreamerAvatar streamer={streamer} size={"lg"}/>
          <div className="stream-card-content">
            <div className="stream-name">
              <a href={`/live/${streamer.slug}`} className="stream-link">{streamer.username}</a>
              {renderBadge()}
            </div>
            <p className="stream-description">{streamer.shortDescription}</p>
          </div>
          {renderLiveStatus()}
        </div>
      </Wrapper>
    </div>
  }

  function renderSocials() {
    if (streamer.socials.length === 0) {
      return <></>
    }
    const sorted = Sort.byDisplayPriority(streamer.socials);
    return <div className="stream-card-social">
      {sorted.slice(0, 3).map((social: ApiStreamerSocial) => {
        return <a key={social.id} href={social.url} target={"_blank"} rel={"noreferrer noopener"}>{getStreamerImageBySocialType(social.type)}</a>
      })}
    </div>
  }

  function renderBadge() {
    if (!streamer.isLive) {
      return <span className="badge badge-offline">Offline</span>
    }
    return <span className="badge badge-online">{streamer.viewers}</span>
  }

  function renderLiveStatus() {
    if (!streamer.isLive) {
      return <div className="stream-card-bottom justify-content-center">
        <a href={`/live/${streamer.slug}`} className="play-live">Stream Offline</a>
      </div>
    }
    return <div className="stream-card-bottom">
      <div className="stream-game">
        <StreamerGameIcon game={streamer.game}/>
        <StreamerGameName streamer={streamer} truncate={20}/>
      </div>
      <a href={`/live/${streamer.slug}`} className="play-live">Oglądaj Live</a>
    </div>
  }

  return render();
}